/**
 * 管理后台：分组管理
 */
import { useState } from 'react';
import { Modal, Form } from 'antd';
import { message } from '../utils/antdMessage';

export default function useAdminGroups({ apiRequest }) {
  const [groups, setGroups] = useState([]);
  const [groupForm] = Form.useForm();
  const [groupModalVisible, setGroupModalVisible] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);
  const [selectedGroupKeys, setSelectedGroupKeys] = useState([]);
  const [groupSearch, setGroupSearch] = useState('');

  const fetchGroups = async () => {
    const data = await apiRequest('/api/admin/groups');
    if (data.success) setGroups(data.groups);
  };
  const handleSaveGroup = async (values) => {
    let url, method;
    if (editingGroup) {
      url = `/api/admin/groups/${editingGroup.id}`;
      method = 'PUT';
    } else {
      url = '/api/admin/groups';
      method = 'POST';
    }
    const data = await apiRequest(url, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(values) });
    if (data.success) {
      message.success('保存成功');
      setGroupModalVisible(false);
      setEditingGroup(null);
      groupForm.resetFields();
      fetchGroups();
    } else {
      message.error(data.error || '保存失败');
    }
  };
  const handleDeleteGroup = async (id) => {
    Modal.confirm({
      title: '确定要删除该分组吗？',
      onOk: async () => {
        const data = await apiRequest(`/api/admin/groups/${id}`, { method: 'DELETE' });
        if (data.success) fetchGroups();
      }
    });
  };
  const handleEditGroup = (group) => {
    setEditingGroup(group);
    groupForm.setFieldsValue(group);
    setGroupModalVisible(true);
  };
  const handleAddGroup = () => {
    setEditingGroup(null);
    groupForm.resetFields();
    setGroupModalVisible(true);
  };

  // 分组上移/下移排序（仅在无搜索过滤时，基于完整列表重排，避免打乱其余分组）
  const handleMoveGroup = async (groupId, direction) => {
    try {
      if (groupSearch) {
        message.warning('请先清空搜索再调整排序');
        return;
      }
      const currentGroups = [...groups];
      const currentIndex = currentGroups.findIndex(g => g.id === groupId);

      if (currentIndex === -1) {
        message.error('未找到指定分组');
        return;
      }

      let targetIndex;
      if (direction === 'up' && currentIndex > 0) {
        targetIndex = currentIndex - 1;
      } else if (direction === 'down' && currentIndex < currentGroups.length - 1) {
        targetIndex = currentIndex + 1;
      } else {
        message.warning(direction === 'up' ? '已经是第一个' : '已经是最后一个');
        return;
      }

      const newOrder = [...currentGroups];
      const movedGroup = newOrder.splice(currentIndex, 1)[0];
      newOrder.splice(targetIndex, 0, movedGroup);
      const ids = newOrder.map(g => g.id);

      const response = await apiRequest('/api/admin/groups/sort', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ids })
      });

      if (response.success) {
        message.success('排序更新成功');
        fetchGroups();
      } else {
        message.error(response.error || '排序更新失败');
      }
    } catch (error) {
      console.error('分组排序错误:', error);
      message.error('排序操作失败');
    }
  };

  return {
    groups, groupForm, groupModalVisible, setGroupModalVisible, editingGroup, selectedGroupKeys, setSelectedGroupKeys,
    groupSearch, setGroupSearch,
    fetchGroups, handleAddGroup, handleEditGroup, handleDeleteGroup, handleMoveGroup, handleSaveGroup
  };
}
